import React, { useState, useMemo } from 'react';
import Summary from '@/components/Summary';
import {
  IncomeEvaluations,
  TradingWinRate,
  TradingDirectionPreference,
  TradingFrequencyAnalysis
} from './components/TradingTab';
import ActionBar from './components/ActionBar.tsx';
import { ScrollArea } from '@/components/ui/scroll-area';
import { TotalData, TradingTabKeyNames } from './index.type';

const TradingTab: React.FC<{
  totalData: Pick<TotalData, TradingTabKeyNames>;
}> = ({ totalData }) => {
  // 选中的指标
  const [selectedMetrics, setSelectedMetrics] = useState({
    industryDistribution: true,
    tradingEvaluation: false
  });

  // 全选状态
  const selectAll = useMemo(() => {
    const values = Object.values(selectedMetrics);
    return values.length > 0 && values.every(v => v);
  }, [selectedMetrics]);

  // 半选状态
  const isIndeterminate = useMemo(() => {
    const values = Object.values(selectedMetrics);
    const checkedCount = values.filter(v => v).length;
    return checkedCount > 0 && checkedCount < values.length;
  }, [selectedMetrics]);

  // 处理全选
  const handleSelectAll = (value: boolean) => {
    const newMetrics = { ...selectedMetrics };
    Object.keys(newMetrics).forEach(key => {
      newMetrics[key as keyof typeof selectedMetrics] = value;
    });
    setSelectedMetrics(newMetrics);
  };

  return (
    <>
      <ScrollArea className="scroll-area-block h-full w-full">
        <div className="rounded-lg bg-white p-4 pb-16">
          {/* 总结 */}
          <Summary
            content={totalData.investment_behavior_analysis}
            isShowSuggestions={false}
          />

          {/* 收益评估 */}
          <IncomeEvaluations selectedMetrics={selectedMetrics} />

          {/* 交易胜算 */}
          <TradingWinRate
            selectedMetrics={selectedMetrics}
            totalData={totalData}
          />

          {/* 交易方向偏好 */}
          <TradingDirectionPreference
            selectedMetrics={selectedMetrics}
            totalData={totalData}
          />

          {/* 交易频率分析 */}
          <TradingFrequencyAnalysis
            selectedMetrics={selectedMetrics}
            totalData={totalData}
          />
        </div>
      </ScrollArea>
      {/* 操作栏 */}
      <ActionBar
        selectAll={selectAll}
        isIndeterminate={isIndeterminate}
        onUpdateSelectAll={handleSelectAll}
      />
    </>
  );
};

export default TradingTab;
